import React, {
  forwardRef,
  LegacyRef,
  useCallback,
  useEffect,
  useState,
} from "react";
import { IconProps, useApiProps } from "../icon";
// import "../style/css";

const LogoWechatIcon = forwardRef<SVGSVGElement, IconProps>(
  (props: IconProps, ref: LegacyRef<SVGSVGElement>) => {
    const {
      colors = [],
      className,
      id = "",
      hover = "",
      size,
      disabled = false,
      style,
      color,
      onMouseEnter,
      onMouseLeave,
      ...resultProps
    } = props;
    //@ts-ignore
    const { sizeStyle, cls } = useApiProps({
      className,
      initColor: ["currentColor"],
      initName: "logo-wechat",
      colors,
      id,
      hover,
      size,
      style,
      disabled,
      color,
    });
    // 默认的color 列表
    const [colorList, setColorList] = useState(["currentColor"]);
    const [colorsProps, setColorsProps] = useState(["currentColor"]);
    const [defaultColor, _] = useState(["currentColor"]);

    useEffect(() => {
      if (typeof colors === "string" && "logo-wechat".indexOf("-colored") === -1) {
        const col = JSON.parse(JSON.stringify(["currentColor"]));
        const find = col.find((item) => item === "currentColor");
        let _col = col;
        if (find) {
          _col = col.map((item) => {
            if (item === "currentColor") {
              item = colors;
            }
            return item;
          });
        } else {
          _col[0] = colors;
        }
        setColorList(_col);
        setColorsProps(_col);
      }

      // 如果colors 是数组
      if (colors instanceof Array && "logo-wechat".indexOf("-colored") === -1) {
        // 获取数组中的对象
        const colorList1 = JSON.parse(JSON.stringify(["currentColor"]));
        colors.forEach((col) => {
          // 获取到修改的元素
          const findColorIndex = colorList1.findIndex(
            (v) => v === col.targetColor
          );
          if (findColorIndex >= 0) {
            colorList1[findColorIndex] = col.reviseColor;
          }
        });
        setColorList([...colorList1]);
        setColorsProps([...colorList1]);
      }

      if (
        color &&
        typeof color === "string" &&
        "logo-wechat".indexOf("-colored") === -1
      ) {
        const col = JSON.parse(JSON.stringify(["currentColor"]));
        const find = col.find((item) => item === "currentColor");
        let _col = col;
        if (find) {
          _col = col.map((item) => {
            if (item === "currentColor") {
              item = color;
            }
            return item;
          });
        } else {
          _col[0] = color;
        }
        setColorList(_col);
        setColorsProps(_col);
      }
    }, [JSON.stringify(colors), color, defaultColor]);

    const handleMouseEnter = useCallback(
      (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
        onMouseEnter && onMouseEnter(event);
        if (!hover || hover.length === 0) return;
        if (colors instanceof Array && "logo-wechat".indexOf("-colored") === -1) {
          if (hover instanceof Array && "logo-wechat".indexOf("-colored") === -1) {
            // 获取数组中的对象
            const colorList1 = JSON.parse(JSON.stringify(colorList));
            hover.forEach((col) => {
              // 获取到修改的元素
              const findColorIndex = colorList1.findIndex(
                (v) => v === col.targetColor
              );
              if (findColorIndex >= 0) {
                colorList1[findColorIndex] = col.reviseColor;
              }
            });
            setColorList([...colorList1]);
          }
        }

        if (typeof colors === "string" && "logo-wechat".indexOf("-colored") === -1) {
          if (typeof hover === "string") {
            const col = JSON.parse(JSON.stringify(colorList));
            const find = col.find((item) => item === colors);
            let _col = col;
            if (find) {
              _col = col.map((item) => {
                if (item === colors) {
                  item = hover;
                }
                return item;
              });
            } else {
              _col[0] = hover;
            }
            setColorList(_col);
          }
        }

        if (
          color &&
          typeof color === "string" &&
          "logo-wechat".indexOf("-colored") === -1
        ) {
          if (typeof hover === "string") {
            const col = JSON.parse(JSON.stringify(colorList));
            const find = col.find((item) => item === color);
            let _col = col;
            if (find) {
              _col = col.map((item) => {
                if (item === color) {
                  item = hover;
                }
                return item;
              });
            } else {
              _col[0] = hover;
            }
            setColorList(_col);
          }
        }

        if (
          !color &&
          colors.length === 0 &&
          typeof hover === "string" &&
          "logo-wechat".indexOf("-colored") === -1
        ) {
          const col = JSON.parse(JSON.stringify(colorList));
          const find = col.find((item) => item === "currentColor");
          let _col = col;
          if (find) {
            _col = col.map((item) => {
              if (item === "currentColor") {
                item = hover;
              }
              return item;
            });
          } else {
            _col[0] = hover;
          }
          setColorList(_col);
        }

        if (
          !color &&
          colors.length === 0 &&
          hover instanceof Array &&
          "logo-wechat".indexOf("-colored") === -1
        ) {
          // 获取数组中的对象
          const colorList1 = JSON.parse(JSON.stringify(colorList));
          hover.forEach((col) => {
            // 获取到修改的元素
            const findColorIndex = colorList1.findIndex(
              (v) => v === col.targetColor
            );
            if (findColorIndex >= 0) {
              colorList1[findColorIndex] = col.reviseColor;
            }
          });
          setColorList([...colorList1]);
        }
      },
      [colorList, defaultColor, colors, color, hover]
    );

    const handleMouseLeave = useCallback(
      (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
        onMouseLeave && onMouseLeave(event);
        if (!hover || hover.length === 0) return;
        let _defaultColor = JSON.parse(JSON.stringify(defaultColor));
        if (colorsProps) {
          _defaultColor = JSON.parse(JSON.stringify(colorsProps));
        }
        setColorList(_defaultColor);
      },
      [colorsProps, defaultColor, hover]
    );

    return <svg id="logo-wechat"  style={sizeStyle}  className={cls}  ref={ref}  onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} {...resultProps}  xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M10.9122 7.16659C8.74181 7.16659 7.15755 8.66323 7.15755 10.3089C7.15755 11.9545 8.74181 13.4511 10.9122 13.4511C11.3394 13.4511 11.7484 13.3913 12.1286 13.282L12.3599 13.2155L13.2267 13.5953L13.0731 12.9055L13.4167 12.6473C14.2041 12.0555 14.6667 11.2145 14.6667 10.3089C14.6667 8.66323 13.0825 7.16659 10.9122 7.16659ZM5.82422 10.3089C5.82422 7.74725 8.1989 5.83325 10.9122 5.83325C13.6254 5.83325 16.0001 7.74725 16.0001 10.3089C16.0001 11.5424 15.4361 12.64 14.5567 13.4339L14.993 15.3932H14.0073L12.2578 14.6265C11.8282 14.7297 11.3769 14.7845 10.9122 14.7845C8.1989 14.7845 5.82422 12.8705 5.82422 10.3089Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/><path d="M5.96278 2.44661C3.30372 2.44661 1.33333 4.26852 1.33333 6.30474C1.33333 7.41602 1.90228 8.4435 2.86201 9.16679L3.19915 9.42087L3.01575 10.3073L4.02507 9.81612L4.28122 9.89966C4.76113 10.0562 5.28126 10.1481 5.82681 10.1612C5.91206 7.78491 8.04762 5.99865 10.5585 5.84419C10.2883 4.00172 8.41944 2.44661 5.96278 2.44661ZM0 6.30474C0 3.34301 2.77191 1.11328 5.96278 1.11328C9.15365 1.11328 11.9256 3.34301 11.9256 6.30474C11.9256 6.38561 11.9234 6.4661 11.9192 6.54618L11.8838 7.22076L11.2097 7.17642C11.1116 7.16996 11.0124 7.16667 10.9121 7.16667C8.74176 7.16667 7.1575 8.66331 7.1575 10.3089C7.1575 10.4433 7.16758 10.5754 7.18708 10.7047L7.29247 11.4042L6.58802 11.468C6.38236 11.4867 6.17376 11.4962 5.96278 11.4962C5.32541 11.4962 4.70977 11.4092 4.13147 11.2472L2.2599 12.1579H1.2713L1.72601 9.96009C0.674276 9.03578 0 7.74977 0 6.30474Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/><path d="M8.7207 9.29555C8.7207 8.8966 9.04409 8.57312 9.44282 8.57312C9.842 8.57312 10.1653 8.89657 10.1653 9.29555C10.1653 9.69453 9.842 10.018 9.44282 10.018C9.04409 10.018 8.7207 9.69451 8.7207 9.29555ZM11.6657 9.29555C11.6657 8.89657 11.9891 8.57312 12.388 8.57312C12.7871 8.57312 13.1103 8.8966 13.1103 9.29555C13.1103 9.69451 12.7871 10.018 12.388 10.018C11.9891 10.018 11.6657 9.69453 11.6657 9.29555Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/><path d="M3.36084 4.84006C3.36084 4.37603 3.73707 4 4.2009 4C4.66506 4 5.04113 4.37603 5.04113 4.84006C5.04113 5.30424 4.66508 5.68029 4.2009 5.68029C3.73705 5.68029 3.36084 5.30424 3.36084 4.84006ZM6.89497 4.84006C6.89497 4.37603 7.27104 4 7.73519 4C8.19916 4 8.57541 4.37601 8.57541 4.84006C8.57541 5.30426 8.19918 5.68029 7.73519 5.68029C7.27102 5.68029 6.89497 5.30424 6.89497 4.84006Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g></svg>;
  }
);

LogoWechatIcon.displayName = "LogoWechatIcon";

export default LogoWechatIcon;
